module.exports = __webpack_public_path__ + "img/img-intro-app-3-tw.35277242.svg";